module.exports = __webpack_public_path__ + "files/2a2efd69f18fc5a205b95c8bdf06766e.svg";